const BackIcon = () =>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="16.516" height="8" viewBox="0 0 16.516 8">
            <path d="M15.871 3.355H2.208L4.47 1.102a.645.645 0 1 0-.91-.914L.19 3.543a.646.646 0 0 0 0 .914l3.37 3.355a.645.645 0 0 0 .911-.914L2.208 4.645H15.87a.645.645 0 1 0 0-1.29z" fill="#000" fillRule="nonzero"/>
        </svg>
    )
}
export default BackIcon